import { EventEmitter } from 'eventemitter3';

const EE = new EventEmitter();
const context = {};

export {
  EE,
  context,
};
